import { download, generateCsv } from "export-to-csv";
import { csvConfig } from "../../Utils/ExportToCsv";

export const handleExportDataForUserRole= (data) => {
   if (data && data.length > 0) {
    const formattedData = data.map((item) => {
        return {
            RoleName: item?.rolename || '',
            RoleType: item?.roletype || '',
            ModuleAccess: item?.modules || '',
            NumberOfUsers: item?.numberOfUsers || '',
        };
    });

    const csv = generateCsv(csvConfig)(formattedData);
    download(csvConfig)(csv);
}

};